import type { ICollectionsRepository } from '@domain/usecases/collections/CollectionsRepository';
import { FirestoreCollectionRepository } from '@infrastructure/firebase/firestore/FirestoreCollectionRepository';

export const makeCollectionRepository = (): ICollectionsRepository => {
	return new FirestoreCollectionRepository();
};
